import axios from 'axios';

const instance = axios.create({
  baseURL: 'https://api-app.tanaescola.com/api',
  //baseURL: 'https://api-app-hml.tanaescola.com:8443/api',
  // baseURL: 'http://localhost:5050/api'  
});

export default instance;